import React from 'react';
import PropTypes from 'prop-types';
import envAPI from '../../../api/api-env';
import { ActivityModal } from 'shared-components/search-module';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

const withActivityDropdownHoc = (Component) => {
  class HOC extends React.Component {
    constructor (props) {
      super(props);
      this.initialState = {
        activity: '',
        activityId: '',
        activities: [],
        activitiesList: [],
        placeholder: 'What are you planning?',
        showModal: false,
        placeholderColor: 'placeholder-color-change'
      };

      this.state = this.initialState;

      this.onFocusActivity = this.onFocusActivity.bind(this);
      this.onBlurActivity = this.onBlurActivity.bind(this);
      this.onChangeActivity = this.onChangeActivity.bind(this);
      this.onClickActivity = this.onClickActivity.bind(this);
      this.toggleModal = this.toggleModal.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onInputOnclick = this.onInputOnclick.bind(this);
      this.matchActivity = this.matchActivity.bind(this);
    }

    componentDidMount () {
      const activity = _.get(this.props, 'selectedFilters.useTypeObj', '');
      const activityId = _.get(this.props, 'selectedFilters.useTypeId', '');
      /* setting search keyword cookie when user lands on this page directly */
      if (PSSessions) {
        PSSessions.set.thisCookie('PSSK', activity, Date.now() + 3888000000);
      }
      const locale = SharedIntlProviderHOC.getLocale();
      envAPI.getActivities(locale, res => {
        const activities = res.response;
        const match = this.matchActivity(activities, activityId);

        const preFillActivityDropdown = _.get(match, 'dropdown');
        const preFillActivityId = _.get(match, 'id');

        this.setState({
          activity: activity && preFillActivityDropdown,
          activityId: activityId && preFillActivityId,
          activities,
          activitiesList: []
        });
      });
      // we pass typeAheadInput up to the parent component and becomes this.activityRef ex: (hero component)
      this.props.activityRef(this.typeAheadInput);
    }

    matchActivity (activities, activityId) {
      // tries to find an exact match of activities based on ID
      // if none is found, then we use sifter to find a close approximation
      let match = {};
      const exactMatch = activities.find(act => act.id === activityId)

      if (exactMatch) {
        match = exactMatch
      }
      else {
        const sifter = new Sifter(activities);
        const fuzzyMatch = (sifter.search(activityId,
          { fields: ['id'],
            limit: 1
          })).items || [];
        const matchSifterId = _.get(fuzzyMatch, '[0].id');
        match = _.get(activities, `[${matchSifterId}]`)
      }

      return match;
    }

    onChangeActivity (e) {
      const { activities } = this.state;
      const activity = e.currentTarget.value;
      this.setState({
        activity
      }, () => {
        if (activity) return this.getActivitySuggestions(activity);
        return this.setState({
          activityId: '',
          activitiesList: []
        });
      });
    }

    onFocusActivity () {
      const { activity } = this.state;
      this.setState({
        placeholder: 'Enter your specific activity',
        placeholderColor: ''
      });
      if (activity) return this.getActivitySuggestions(activity);
      return null;
    }

    onClickActivity (e, closeDropdownOrModal) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      const activityId = _.get(e, 'currentTarget.dataset.value', '');
      const filteredActivity = _.filter(this.state.activities, { id: activityId })[0] || {};
      const activity = filteredActivity.dropdown;
      const skt = this.state.activity ? 'input' : 'default';
      PSSessions.Cookies.set('PSSK', activity, Date.now() + 3888000000);
      PSSessions.Cookies.set('PSSKT', skt, Date.now() + 3888000000);
      if (_.isFunction(closeDropdownOrModal)) closeDropdownOrModal();
      setTimeout(() => {
        this.setState({
          activity,
          activityId
        });
        if (_.isFunction(this.props.filterResults)) {
          this.props.filterResults({ a: activity });
        }
      }, 200);
    }

    onBlurActivity (e) {
      if (e) e.stopPropagation();
      this.setState({
        placeholder: this.initialState.placeholder,
        placeholderColor: this.initialState.placeholderColor
      });
    }

    onKeyDown (e) {
      const firstOnList = document.getElementById('activity-list-0');
      if (40 === e.keyCode && firstOnList) {
        // If user presses the down arro\w,
        // we select the first item from the dropdown
        e.preventDefault();
        firstOnList.focus();
      } else if (13 === e.keyCode && firstOnList) {
        // If user hits enter, we select the first item from the dropdown,
        // and blur out of the input field
        firstOnList.click();
        e.target.blur();
      }
    }

    onInputOnclick (e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
        e.target.select();
      }
    }

    getActivitySuggestions (input) {
      const { Sifter } = window;
      const { activities, activityId } = this.state;
      const siftedActivity = new Sifter(activities).search(input, { fields: ['dropdown', 'use-subtype', 'display_use_type'], limit: 5 });
      const activitiesList = !_.isEmpty(siftedActivity) ? _.map(siftedActivity.items, (item) => {
        return activities[item.id];
      }) : [];
      this.setState({
        activityId: activitiesList.length ? activityId : '',
        activitiesList
      });
    }

    toggleModal (e, listToggle) {
      if (e) e.preventDefault();
      const { showModal } = this.state;
      if (_.isFunction(listToggle)) listToggle();
      this.setState({ showModal: !showModal });
    }

    render () {
      return (
        <div>
          <Component
            inputOverlayRef={e => { this.typeAheadInput = e; }}
            activityValue={this.state.activity}
            activity={this.state.activity}
            activityId={this.state.activityId}
            activitiesList={this.state.activitiesList}
            placeholder={this.state.placeholder}
            onFocusActivity={this.onFocusActivity}
            onBlurActivity={this.onBlurActivity}
            onClickActivity={this.onClickActivity}
            onChangeActivity={this.onChangeActivity}
            toggleModal={this.toggleModal}
            onKeyDown={this.onKeyDown}
            inputRef={this.props.inputRef}
            inputClassName={`${this.props.inputClassName} ${this.state.placeholderColor}`}
            inputAttributes={{
              onClick: this.onInputOnclick
            }}
            addOnImage={this.props.addOnImage}
            hideErrorDropdown={!this.state.activity}
          />
          <ActivityModal
            showModal={this.state.showModal}
            activities={this.state.activities}
            onClickActivity={this.onClickActivity}
            closeModal={this.toggleModal}
          />
        </div>
      );
    }
  }
  HOC.propTypes = {
    filterResults: PropTypes.func,
    inputClassName: PropTypes.string,
    inputRef: PropTypes.func,
    activityRef: PropTypes.func,
    addOnImage: PropTypes.object
  };
  return HOC;
};

export default withActivityDropdownHoc;
